const API_URL_PROD = "https://api.dythaticekubranur.com";
const API_URL_DEV = "http://localhost:3000";

export const API_URL = process.env.NODE_ENV === "development" ? API_URL_DEV : API_URL_PROD;
